<template>
    <div id="remember">

        <div class="box">
            <img class="logo" src="/img/logo_top.png">
            <div id="message_password" class="message" v-show="message">{{message}}</div>
            <div v-show="intime">
                <div class="desc">{{$t("views.password.description")}}</div>
                <input type="password" name="password1" v-model="input.password1" :placeholder="$t('views.password.new_password')" />
                <input type="password" name="password2" v-model="input.password2" :placeholder="$t('views.password.repeat_password')" v-on:keyup.enter="changePassword()" />

                <button type="button" v-on:click="changePassword()">{{$t("views.password.change")}}</button>

                <router-link to="/login" class="login">{{$t("views.password.login")}}</router-link>
            </div>

        </div>

    </div>
</template>

<script>
    import i18n from '@/i18n';
    import {Api} from '@/core/api.js';
    const api = new Api();

    export default {
        name: 'Changepassword',
        data() {
            return {
                input: {
                    password1: "",
                    password2: ""
                },
                message: false,
                intime: false
            }
        },
        mounted() {
            var timestamp = this.$route.params.time;
            console.log( timestamp + " " + moment( timestamp*1000).format( "YYYY-MM-DD HH:mm:ss" ) );
            if( moment().valueOf() <= moment( timestamp * 1000 ).valueOf() ){
                this.intime = true;
            }
            else{
                this.message = this.$t("views.password.expired");
                document.getElementById( 'message_password' ).classList.remove( 'success' );
                document.getElementById( 'message_password' ).classList.add( 'error' );
            }
        },
        methods: {
            changePassword() {
                var self = this;
                var password1 = sha256( this.input.password1 );
                var password2 = sha256( this.input.password2 );

                if( password1 != password2 ){
                    self.message = this.$t("views.password.error");
                    document.getElementById( 'message_password' ).classList.remove( 'success' );
                    document.getElementById( 'message_password' ).classList.add( 'error' );
                }
                else {
                    api.post( 'changepass', { id: this.$route.params.id, password: password1 } ).then( function( response ){
                        console.log( response );
                        if( response.status ) {
                            self.message = this.$t("views.password.success");
                            document.getElementById( 'message_password' ).classList.remove( 'error' );
                            document.getElementById( 'message_password' ).classList.add( 'success' );
                            // self.$destroy();
                        } else {
                            self.message = this.$t("views.password.connection_error");
                            document.getElementById( 'message_password' ).classList.remove( 'success' );
                            document.getElementById( 'message_password' ).classList.add( 'error' );
                        }
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    
    #remember {

        margin: auto;
        margin-top: 75px;
        padding: 20px;

        .box {
            max-width: 275px;
            width: 100%;
            margin: 0 auto;

            .logo {
                width: 100%;
                margin-bottom: 5px;
            }
            input{
                width: 100%;
                padding: 15px;
                margin-bottom: 5px;
                border: 1px solid #ccc;
                outline: none;
                font-size: 11pt;
                //background: #ddd;
                //border: none;
                //border-left: 35px solid var(--main_color);
                //border-right: 35px solid var(--main_color);

                &:focus {
                    border: 1px solid var(--main_color);
                }

            }
            button {
                width: 100%;
                padding: 15px;
                outline: none;
                border: none;
                cursor: pointer;
                font-size: 12pt;
                font-family: Speedee-Bold;
                margin-top: 5px;
                border-radius: 3px;
                text-transform: uppercase;
                transition: all 0.5s;
                background: #111;
                color: #fff;

                &:hover {
                    background: var(--main_color);
                    color: #111;
                }
            }

            .desc {
                font-size: 10pt;
                margin: 10px 0;
                color: #333;
                display: block;
            }

            .login {
                font-size: 10pt;
                margin-top: 20px;
                color: #888;
                cursor: pointer;
                display: block;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }

        }
    }

</style>